module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pro/exchange/exchange-show/exchange-show.component.scss
// module id = ./src/app/views/pro/exchange/exchange-show/exchange-show.component.scss
// module chunks = main